import { useQuery } from '@tanstack/react-query';

import { getGroupedReleaseNotesApi, getLatestReleaseNoteApi } from 'api/releaseNotes';
import type {
  GetGroupedReleaseNotesResponseDTO,
  LatestReleaseNoteDto,
} from 'declarations/dto/releaseNotes';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchGroupedReleaseNotes = (): ReturnType<
  typeof useQuery<GetGroupedReleaseNotesResponseDTO, ApiErrorI>
> =>
  useQuery<GetGroupedReleaseNotesResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchGroupedReleaseNotes],
    async (): Promise<GetGroupedReleaseNotesResponseDTO> => getGroupedReleaseNotesApi(),
    { staleTime: RequestStaleTimeE.GroupedReleaseNotes }
  );

export const useFetchLatestReleaseNote = (): ReturnType<
  typeof useQuery<LatestReleaseNoteDto, ApiErrorI>
> =>
  useQuery<LatestReleaseNoteDto, ApiErrorI>(
    [RequestQueryKeysE.FetchLatestReleaseNote],
    async (): Promise<LatestReleaseNoteDto> => getLatestReleaseNoteApi(),
    { staleTime: RequestStaleTimeE.GroupedReleaseNotes }
  );
